module.exports = __webpack_public_path__ + "static/media/third_party_certificate_image.ae72a661.svg";